import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useWorkspaceProxyMutations from "common/datahooks/useWorkspaceProxyMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { CustomProxy } from "common/types";

interface DeleteProxyProps {
  proxy: CustomProxy;
  onBack: () => void;
  onSuccess: () => void;
}

export default function DeleteProxy({
  proxy: { id, name },
  onBack,
  onSuccess,
}: DeleteProxyProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteProxy, isDeletingProxy } = useWorkspaceProxyMutations();

  function onDelete() {
    deleteProxy({ proxyId: id }).then(() => onSuccess());
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Delete proxy"
        subtitle={
          <>
            Are you sure you want to delete{" "}
            <span className="break-words font-semibold text-black-950">
              {name}
            </span>
            ?
          </>
        }
      />
      <Footer className="items-center justify-end">
        <Button
          variant="secondary-black"
          onClick={onBack}
          disabled={isDeletingProxy}
        >
          Cancel
        </Button>

        <Button
          variant="outline-danger"
          isLoading={isDeletingProxy}
          onClick={onDelete}
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
